/* ============================================
   Section: Brand Anchor Nav — scrollspy
   Marque le lien correspondant à la section visible.
   ============================================ */

(function () {
  'use strict';

  function initAnchorNav(nav) {
    if (nav.hasAttribute('data-anchor-nav-init')) return;
    nav.setAttribute('data-anchor-nav-init', '');

    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-anchor-nav-link]'));
    if (!links.length) return;

    // Associe chaque lien à sa cible réellement présente dans le DOM.
    // Une section pilotée par metafield peut ne rien rendre : on masque alors son lien
    // plutôt que de laisser une ancre morte dans le sous-menu.
    var entries = links.reduce(function (acc, link) {
      var id = (link.getAttribute('href') || '').replace('#', '');
      var target = id ? document.getElementById(id) : null;

      if (target) {
        link.hidden = false;
        acc.push({ link: link, target: target });
      } else {
        link.hidden = true;
      }

      return acc;
    }, []);

    // Plus aucune cible : le sous-menu n'a plus de raison d'être affiché
    if (!entries.length) {
      nav.hidden = true;
      return;
    }

    nav.hidden = false;

    function setActive(link) {
      entries.forEach(function (entry) {
        entry.link.classList.toggle('is-active', entry.link === link);
      });
    }

    // Clic : état actif immédiat, sans attendre l'observer
    entries.forEach(function (entry) {
      entry.link.addEventListener('click', function () {
        setActive(entry.link);
      });
    });

    if (!('IntersectionObserver' in window)) {
      setActive(entries[0].link);
      return;
    }

    var visible = [];

    var observer = new IntersectionObserver(
      function (records) {
        records.forEach(function (record) {
          var index = visible.indexOf(record.target);
          if (record.isIntersecting && index === -1) {
            visible.push(record.target);
          } else if (!record.isIntersecting && index !== -1) {
            visible.splice(index, 1);
          }
        });

        if (!visible.length) return;

        // La section active est la plus haute parmi celles visibles
        var topMost = visible.reduce(function (best, node) {
          return node.getBoundingClientRect().top < best.getBoundingClientRect().top ? node : best;
        });

        var match = entries.filter(function (entry) {
          return entry.target === topMost;
        })[0];

        if (match) setActive(match.link);
      },
      { rootMargin: '-25% 0px -60% 0px', threshold: 0 }
    );

    entries.forEach(function (entry) {
      observer.observe(entry.target);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-anchor-nav]').forEach(initAnchorNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Éditeur de thème : ré-initialise après un rechargement de section
  document.addEventListener('shopify:section:load', initAll);
})();
